import { render } from "./RichTextEditor.vue?vue&type=template&id=7ef655ea"
import script from "./RichTextEditor.vue?vue&type=script&lang=js"
export * from "./RichTextEditor.vue?vue&type=script&lang=js"

import "./RichTextEditor.vue?vue&type=style&index=0&id=7ef655ea&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__